import React, { useState, createContext, useContext, useCallback, useRef } from 'react';

import Modal from 'context/modal/modal';
import { useExchange } from 'context/exchange/ExchangeContext';
import { ConfirmSellBridgeNomModal } from 'components/Exchange/Modals/ConfirmSellBridgeNomModal';
import { ConfirmBuyBridgeNomModal } from 'components/Exchange/Modals/ConfirmBuyBridgeNomModal';
import { ApproveSellBridgeNomModal } from 'components/Exchange/Modals/ApproveSellBridgeNomModal';

export const ModalContext = createContext();
export const useModal = () => useContext(ModalContext);

export const UpdateModalContext = createContext();
export const useUpdateModal = () => useContext(UpdateModalContext);

function ModalProvider({ children }) {
  const [modal, updateModal] = useState(false);
  const [modalContent, updateModalContent] = useState("I'm the Modal Content");
  const { extraAllowanceNeeded } = useExchange();

  const handleModal = useCallback((content = false) => {
    if (content) {
      updateModal(true);
      updateModalContent(content);
    } else {
      updateModal(false);
    }
  }, []);

  const handleModalRef = useRef(handleModal);
  handleModalRef.current = handleModal;
  const extraAllowanceNeededRef = useRef(extraAllowanceNeeded);
  extraAllowanceNeededRef.current = extraAllowanceNeeded;

  const onShowConfirmBuy = useCallback(() => {
    handleModalRef.current(<ConfirmBuyBridgeNomModal />);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onShowConfirmSell = useCallback(() => {
    // console.log('onShowConfirmSell', extraAllowanceNeededRef.current.amount);
    if (extraAllowanceNeededRef.current.amount > 0) {
      handleModalRef.current(<ApproveSellBridgeNomModal />);
    } else {
      handleModalRef.current(<ConfirmSellBridgeNomModal />);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const contextValue = {
    handleModal,
    modal,
    modalContent,
    onShowConfirmBuy,
    onShowConfirmSell,
  };

  const updateValue = {
    updateModal,
    updateModalContent,
  };

  return (
    <UpdateModalContext.Provider value={updateValue}>
      <ModalContext.Provider value={contextValue}>
        <Modal />
        {children}
      </ModalContext.Provider>
    </UpdateModalContext.Provider>
  );
}

export default ModalProvider;
